module.exports = __webpack_public_path__ + "static/media/my-career.af46c13b.png";